import React from "react"
import ReactDOM from "react-dom"
import { App } from "./ui/home/app"
import "./ui/home/index.css"

ReactDOM.render(<App />, document.getElementById("root"))
